import React, { useState } from 'react';
import axios from 'axios';
import API_URL from './config/apiConfig';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';

const AuthForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    // const { setAuthToken } = useAuth();  // utilise setAuthToken existant
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            // Appel au back pour récupération du token
            const { data } = await axios.post(
                `${API_URL}/auth/login`,
                { email, password }
            );
            const { token, userName, userId, userEmail, isAdmin } = data;

            // 1) Persister token en localStorage
            localStorage.setItem('token', token);
            // 2) Configurer axios pour inclure le token
            axios.defaults.headers.common['Authorization'] = token;
            // 3) Mettre à jour le contexte avec setAuthToken
            // setAuthToken({ token, userId, userName, userEmail, isAdmin });
            login(token, userId, userName, userEmail, isAdmin);

            // 4) Redirection vers la page principale (chat)
            navigate('/', { replace: true });
        } catch (err) {
            setError(
                err.response?.data?.msg ||
                err.message ||
                'Erreur de connexion'
            );
        } finally {
            setLoading(false);
        }
    };

    const handleForgotPassword = () => {
        navigate('/forgot-password');
    };

    return (
        <div className="md:pt-12 background flex flex-col justify-center min-h-screen">
            <img
                src="https://i.ibb.co/XZhwFBkw/image-15.png"
                className="w-44 md:w-80 h-auto mx-auto mt-12 md:mt-32"
                alt="Logo"
            />
            <div className="w-7/12 bg-[#2F4F6F] rounded-lg mx-auto my-12 md:m-auto flex flex-col items-center justify-center  h-auto py-8">
                <h2 className="text-2xl text-white font-black text-center pt-4 pb-6">Connexion</h2>
                <form
                    className="flex flex-col w-full items-center space-y-4"
                    onSubmit={handleSubmit}
                >
                    <input
                        className="rounded-lg p-2 text-lg w-3/4"
                        type="text"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        className="rounded-lg p-2 text-lg w-3/4"
                        type="password"
                        placeholder="Mot de passe"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    {error && (
                        <div className="text-red-600 text-center">
                            {error}
                        </div>
                    )}
                    <button
                        className="bg-[#5A9BD5] py-3 px-8 rounded-lg text-white font-bold hover:bg-blue-600 transition"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? 'Chargement...' : 'Connexion'}
                    </button>
                </form>
                <button onClick={handleForgotPassword} className="mt-4 text-white underline">
                    mot de passe oublié
                </button>
            </div>
        </div>
    );
};

export default AuthForm;
